import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import OutcomeFolder from "../OutcomeFolder/index.js";
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
import { stylesShape } from "../../store/shapes.js";
var OutcomeFolderList = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomeFolderList, _React$Component);
  var _super = _createSuper(OutcomeFolderList);
  function OutcomeFolderList() {
    _classCallCheck(this, OutcomeFolderList);
    return _super.apply(this, arguments);
  }
  _createClass(OutcomeFolderList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        outcomes = _this$props.outcomes,
        getOutcomeSummary = _this$props.getOutcomeSummary,
        setActiveCollection = _this$props.setActiveCollection,
        toggleExpandedIds = _this$props.toggleExpandedIds,
        activeCollectionId = _this$props.activeCollectionId;
      if (outcomes.length === 0) {
        return jsx("div", null);
      }
      return jsx("div", {
        css: this.props.styles.picker
      }, outcomes.map(function (outcome) {
        return jsx(OutcomeFolder, {
          key: outcome.id,
          outcome: outcome,
          getOutcomeSummary: getOutcomeSummary,
          setActiveCollection: setActiveCollection,
          toggleExpandedIds: toggleExpandedIds,
          activeCollectionId: activeCollectionId
        });
      }));
    }
  }]);
  OutcomeFolderList.displayName = "OutcomeFolderList";
  return OutcomeFolderList;
}(React.Component), _class2.propTypes = {
  getOutcomeSummary: PropTypes.func.isRequired,
  setActiveCollection: PropTypes.func.isRequired,
  outcomes: PropTypes.array.isRequired,
  toggleExpandedIds: PropTypes.func.isRequired,
  activeCollectionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: stylesShape
}, _class2.defaultProps = {
  activeCollectionId: null
}, _class2)) || _class);
export { OutcomeFolderList as default };